const APP_BASE = '/app'

export enum Routes {
  home = '',
  returns = 'returns',
  sources = 'sources',
  emailUpdate = 'emailUpdate',
  document = 'document',
  customerDetails = 'customer',
  filesWithErrors = 'filesWithErros',
}

export const AbsoluteRoutes = {
  home: APP_BASE,
  returns: `${APP_BASE}/${Routes.returns}`,
  sources: `${APP_BASE}/${Routes.sources}`,
  emailUpdate: `${APP_BASE}/${Routes.emailUpdate}`,
  document: `${APP_BASE}/${Routes.document}`,
  customerDetails: `${APP_BASE}/${Routes.customerDetails}`,
  filesWithErrors: `${APP_BASE}/${Routes.filesWithErrors}`,
} as const
